import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';


export function FieldTableDefaultColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'default',
            width: () => 'auto',
            className: () => 'column-wide-enough',
            readOnly:true,
            // eslint-disable-next-line react/display-name
            renderViewer: (props: FieldRendererProps<any,any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return value;
            },
            renderExport:(cell,props: FieldRendererProps<any,any>):any => {
                let value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if (typeof value == 'object') {
                    if (value) {
                        value = value.toString();
                        cell.v = value;
                    } else {
                        cell.v = '';
                    }
                }
                else {
                    cell.v = value;
                }
                return cell;
            }
        });
    }, [context]);
    return null;
}
